import { render, staticRenderFns } from "./AssumptionsImpactsApplicabilityRate.vue?vue&type=template&id=70cfc47e&"
import script from "./AssumptionsImpactsApplicabilityRate.vue?vue&type=script&lang=js&"
export * from "./AssumptionsImpactsApplicabilityRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports